import { getAllNetworks } from "@iota/iota-sdk/client";
import {
  resolveFloorPriceRule,
  resolveKioskLockRule,
  resolvePersonalKioskRule,
  resolveRoyaltyRule
} from "./tx/rules/resolve.js";
function getBaseRules({
  royaltyRulePackageId,
  kioskLockRulePackageId,
  personalKioskRulePackageId,
  floorPriceRulePackageId
}) {
  const rules2 = [];
  if (royaltyRulePackageId) {
    rules2.push({
      rule: `${royaltyRulePackageId}::royalty_rule::Rule`,
      packageId: royaltyRulePackageId,
      resolveRuleFunction: resolveRoyaltyRule
    });
  }
  if (kioskLockRulePackageId) {
    rules2.push({
      rule: `${kioskLockRulePackageId}::kiosk_lock_rule::Rule`,
      packageId: kioskLockRulePackageId,
      resolveRuleFunction: resolveKioskLockRule,
      hasLockingRule: true
    });
  }
  if (personalKioskRulePackageId) {
    rules2.push({
      rule: `${personalKioskRulePackageId}::personal_kiosk_rule::Rule`,
      packageId: personalKioskRulePackageId,
      resolveRuleFunction: resolvePersonalKioskRule
    });
  }
  if (floorPriceRulePackageId) {
    rules2.push({
      rule: `${floorPriceRulePackageId}::floor_price_rule::Rule`,
      packageId: floorPriceRulePackageId,
      resolveRuleFunction: resolveFloorPriceRule
    });
  }
  return rules2;
}
const rules = Object.values(getAllNetworks()).filter((network) => network.kiosk).flatMap((network) => getBaseRules(network.kiosk));
export {
  getBaseRules,
  rules
};
//# sourceMappingURL=constants.js.map
